import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'kangarootime-ui';
import moment from 'moment';
import './ExistingDirectMessagesList.css';

const ExistingDirectMessagesList = ({
  existingMessages,
  onDirectMessageSelect,
  ...props
}) => {
  if (existingMessages.length === 0) {
    return null;
  }

  return (
    <Fragment>
      <Typography style={{ fontWeight: 600, fontSize: '0.875rem', marginTop: 8 }}>Recent Conversations</Typography>
      <ul className='existing-direct-messages-list'>
        { existingMessages.map(directMessageChannel => {
          const { id, name, lastMessageSentAt } = directMessageChannel;

          return (
            <li key={id} onClick={() => onDirectMessageSelect(id, directMessageChannel)}>
              <Typography style={{ flex: 1 }}>{name}</Typography>
              { lastMessageSentAt && <Typography type='meta'>{moment(lastMessageSentAt).fromNow()}</Typography> }
            </li>
          );
        })}
      </ul>
    </Fragment>
  );
};

ExistingDirectMessagesList.propTypes = {
  existingMessages: PropTypes.array,
  onDirectMessageSelect: PropTypes.func
};

export default ExistingDirectMessagesList;
